import { Component, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  UntypedFormBuilder,
  AbstractControl,
  ValidatorFn,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { IUserRequest } from '../../interfaces/user-request';
import { MapService } from '../../services';
import { BBWTMessageService } from '../../services';
declare var pca: any;
import { UserRequestService } from '../../services';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'new-user-request',
  templateUrl: 'new-user-request.component.html',
  styleUrls: ['./new-user-request.component.css'],
})
export class NewUserRequestComponent implements OnInit {
  public isBusy: boolean = false;
  public organisationSubType: number;
  public userRequestForm: UntypedFormGroup;
  private pcaKey: string = '';
  public msgs: any[];
  public vatRegisterCheck: boolean = false;
  public phoneNumber: string;
  public countryCode: string = '+44';
  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private userRequestService: UserRequestService,
    public messageService: BBWTMessageService,
    private mapService: MapService,
  ) {}

  ngOnInit() {
    this.route.data.subscribe((data: any) => {
      this.organisationSubType = data.organisationSubType;

      const emailRegExp = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
      var companyRegNumberExp = new RegExp(/^(((\d{2})|([a-zA-Z]{2}))(\d{6}))$/);
      var driverLicenceRegExp = new RegExp(/^[a-zA-Z9]{5}\d{6}[a-zA-Z9]{2}\d[a-zA-Z]{2}$/);
      //var mobileNumberRegExp = new RegExp(/^\\+447|447|07|00447\\d{9}$/);
      var mobileNumberRegExp = new RegExp(/^\d{3}\s?\d{3}\s?\d{4}$/);
      // set formGroup instance
      this.userRequestForm = this.formBuilder.group({
        id: 0,
        organisationSubTypeId: this.organisationSubType,
        firstName: new UntypedFormControl(
          '',
          Validators.compose(
            this.organisationSubType == 1 || this.organisationSubType == 4
              ? [Validators.required, Validators.maxLength(35), NoEmptyString]
              : [],
          ),
        ),
        surname: new UntypedFormControl(
          '',
          Validators.compose(
            this.organisationSubType == 1 || this.organisationSubType == 4
              ? [Validators.required, Validators.maxLength(35), NoEmptyString]
              : [],
          ),
        ),
        addressLine1: new UntypedFormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
        ),
        addressLine2: new UntypedFormControl(
          '',
          Validators.compose([null, Validators.maxLength(60)]),
        ),
        addressLine3: new UntypedFormControl(
          '',
          Validators.compose([null, Validators.maxLength(60)]),
        ),
        emailAddress: new UntypedFormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.maxLength(254),
            Validators.pattern(emailRegExp),
          ]),
        ),
        town: new UntypedFormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(35), NoEmptyString]),
        ),
        postcode: new UntypedFormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(8), NoEmptyString]),
        ),
        phoneNumber: new UntypedFormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.maxLength(20),
            Validators.pattern(mobileNumberRegExp),
          ]),
        ),
        driverLicence: new UntypedFormControl(
          '',
          Validators.compose([
            this.organisationSubType == 1 ? Validators.required : null,
            Validators.maxLength(16),
            Validators.pattern(driverLicenceRegExp),
          ]),
        ),

        companyName: new UntypedFormControl(
          '',
          Validators.compose(
            this.organisationSubType == 2 ||
              this.organisationSubType == 3 ||
              this.organisationSubType == 5 ||
              this.organisationSubType == 6
              ? [Validators.required, Validators.maxLength(100), NoEmptyString]
              : [],
          ),
        ),
        companyRegistrationNumber: new UntypedFormControl(
          '',
          Validators.compose(
            this.organisationSubType == 2 || this.organisationSubType == 3
              ? [null, Validators.maxLength(8), Validators.pattern(companyRegNumberExp)]
              : [],
          ),
        ),
        vatRegisterCheck: new UntypedFormControl(false, null),
        vatNumber: new UntypedFormControl(
          '',
          Validators.compose(
            (this.organisationSubType == 2 || this.organisationSubType == 3) &&
              this.vatRegisterCheck
              ? [Validators.required, Validators.maxLength(9), NoEmptyString]
              : [],
          ),
        ),
        website: new UntypedFormControl(
          '',
          Validators.compose(
            this.organisationSubType == 2 || this.organisationSubType == 3
              ? [Validators.maxLength(255)]
              : [],
          ),
        ),
        dateOfBirth: new UntypedFormControl(
          '',
          Validators.compose(
            this.organisationSubType == 1 || this.organisationSubType == 4
              ? [this.ageValidator(18)]
              : [],
          ),
        ),
      });

      var that = this;
      this.isBusy = true;
      this.mapService
        .GetPCAKey()
        .then((result) => {
          that.pcaKey = result.key;
          that.isBusy = false;
          that.initPCA();
        })
        .catch(() => {
          that.isBusy = false;
          that.pcaKey = null;
        });
    });
  }

  private ageValidator(minAge: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const today = new Date();
      const birthDate = new Date(control.value);
      const age = today.getFullYear() - birthDate.getFullYear();

      if (age < minAge) {
        return { ageBelowMin: true };
      }

      return null;
    };
  }

  initPCA() {
    setTimeout(() => {
      var options = {
        key: this.pcaKey,
      };

      if (this.organisationSubType == 1 || this.organisationSubType == 4) {
        var fields = [
          {
            element: 'addressLine1',
            field: 'Line1',
            mode: pca.fieldMode.POPULATE | pca.fieldMode.SEARCH,
          },
          { element: 'addressLine2', field: 'Line2', mode: pca.fieldMode.POPULATE },
          { element: 'addressLine3', field: 'Line3', mode: pca.fieldMode.POPULATE },
          { element: 'town', field: 'City', mode: pca.fieldMode.POPULATE },
          {
            element: 'postcode',
            field: 'PostalCode',
            mode: pca.fieldMode.POPULATE | pca.fieldMode.SEARCH,
          },
        ];

        var control = new pca.Address(fields, options);
        control.load();

        control.listen('populate', (address, variations) => {
          this.userRequestForm.patchValue({
            addressLine1: $('#addressLine1').val(),
            addressLine2: $('#addressLine2').val(),
            addressLine3: $('#addressLine3').val(),
            town: $('#town').val(),
            postcode: $('#postcode').val(),
          });
        });
      } else {
        var fields = [
          {
            element: 'companyName',
            field: 'Company',
            mode: pca.fieldMode.POPULATE | pca.fieldMode.SEARCH,
          },
          {
            element: 'addressLine1',
            field: 'Line1',
            mode: pca.fieldMode.POPULATE | pca.fieldMode.SEARCH,
          },
          { element: 'addressLine2', field: 'Line2', mode: pca.fieldMode.POPULATE },
          { element: 'addressLine3', field: 'Line3', mode: pca.fieldMode.POPULATE },
          { element: 'town', field: 'City', mode: pca.fieldMode.POPULATE },
          {
            element: 'postcode',
            field: 'PostalCode',
            mode: pca.fieldMode.POPULATE | pca.fieldMode.SEARCH,
          },
        ];

        var control = new pca.Address(fields, options);
        control.load();

        control.listen('populate', (address, variations) => {
          this.userRequestForm.patchValue({
            companyName: $('#companyName').val(),
            addressLine1: $('#addressLine1').val(),
            addressLine2: $('#addressLine2').val(),
            addressLine3: $('#addressLine3').val(),
            town: $('#town').val(),
            postcode: $('#postcode').val(),
          });
        });
      }
    }, 0);
  }

  Clear() {
    this.userRequestForm.reset();
    this.userRequestForm.controls['id'].setValue(0);
    this.userRequestForm.controls['organisationSubTypeId'].setValue(this.organisationSubType);
  }

  saveForm(form) {
    // Simulate being keyed in to trigger validation, since autofill doesn't trigger any events
    Object.keys(this.userRequestForm.controls).forEach((field) => {
      // {1}
      const control = this.userRequestForm.get(field); // {2}
      control.setValue(control.value);
    });

    if (this.userRequestForm.invalid) {
      return;
    }

    var userRequest = form as IUserRequest;
    if (userRequest.driverLicence) {
      userRequest.driverLicence = userRequest.driverLicence.toUpperCase();
    }

    if (userRequest.phoneNumber) {
      userRequest.phoneNumber = `+44${userRequest.phoneNumber}`;
    }

    if (userRequest.dateOfBirth) {
      userRequest.dateOfBirth = new Date(userRequest.dateOfBirth);
    }

    if (userRequest) this.isBusy = true;
    this.userRequestService
      .sendRequest(userRequest)
      .then((result) => {
        this.isBusy = false;
        this.messageService.ShowSuccess(
          'Send User Request',
          'Your request has been sent for registration. You will be notified when it has been processed. ',
        );
        this.Clear();
      })
      .catch((ex) => {
        this.isBusy = false;
        if (ex instanceof HttpErrorResponse && ex.status == 400) {
          let errors = ex.error as Record<string, string[]>;
          for (let errorsKey in errors) {
            this.messageService.ShowError(`Send User Request`, errors[errorsKey].join('\n'));
          }
        } else {
          this.messageService.ShowError(
            'Send User Request',
            'Unable to register. An error occurred while sending your request. Please try again or contact your administrator.',
          );
        }
      });
  }
  handleVATStatusChange(evt: boolean) {
    const vatNumberCtrl = this.userRequestForm.get('vatNumber');
    this.vatRegisterCheck = evt;
    vatNumberCtrl.setValidators(
      (this.organisationSubType == 2 || this.organisationSubType == 3) && this.vatRegisterCheck
        ? [Validators.required, Validators.maxLength(9), NoEmptyString]
        : [],
    );
    vatNumberCtrl.updateValueAndValidity();
  }
}
